








































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SvcBayi from "@/services/AsesmenAwalBayiBaruLahir";
import { buildBayiInfo, catatanTidakDigabung, BayiInfo } from "@/utility/PartografBayiHelper";
import { CatatanPersalinan } from "@/types/partograf";

@Component
export default class CardInfoBayiLahir extends Vue {
  @Prop({ required: true }) register!: string | number;
  @Prop({ default: null }) catatan!: CatatanPersalinan | null;
  @Prop({ default: null }) tanggal!: string | null;

  bayiList: any[] = [];

  get rows(): BayiInfo[] {
    return buildBayiInfo(this.bayiList, this.catatan, this.tanggal || undefined);
  }

  get catatanTerpisah(): boolean {
    return catatanTidakDigabung(this.bayiList, this.catatan);
  }

  mounted() {
    this.fetchBayi();
  }

  @Watch("register")
  onRegisterChange() {
    this.fetchBayi();
  }

  async fetchBayi() {
    this.bayiList = [];
    if (!this.register) return;
    try {
      const [linked, own] = await Promise.all([
        SvcBayi.getByMotherRegister(this.register).catch(() => null),
        SvcBayi.getByRegister(this.register).catch(() => null),
      ]);
      const list: any[] = [];
      const linkedData = linked && linked.data && linked.data.data;
      if (Array.isArray(linkedData)) list.push(...linkedData);
      const ownData = own && own.data && own.data.data;
      if (ownData && !Array.isArray(ownData)) list.push(ownData);
      const seen = new Set();
      this.bayiList = list.filter((b) => {
        if (!b) return false;
        const key = b.id != null ? b.id : JSON.stringify(b);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    } catch (e) {
      this.bayiList = [];
    }
  }
}
